export function normalizeTone(value) {
  const tone = String(value || "").trim().toLowerCase();
  if (
    [
      "overdue",
      "attention_required",
      "error",
      "failed",
      "quarantined",
      "recovery_failed",
      "high_risk",
      "danger",
    ].includes(tone)
  ) {
    return "overdue";
  }
  if (
    [
      "stale",
      "needs_configuration",
      "warning",
      "locked",
      "plan_locked",
      "inactive",
      "manual_review",
    ].includes(tone)
  ) {
    return "stale";
  }
  if (
    [
      "ready",
      "manual",
      "automation",
      "success",
      "active",
      "delivered",
      "healthy",
      "verified",
      "current",
      "enabled",
      "connected",
    ].includes(tone)
  ) {
    return "ready";
  }
  return "muted";
}

export function toneChipClass(value, baseClass = "tone-chip") {
  return `${baseClass} tone-${normalizeTone(value)}`.trim();
}

export function emptyStateClass(value, extraClasses = []) {
  return ["detail-empty", "empty-state", `tone-${normalizeTone(value)}`]
    .concat(extraClasses.filter(Boolean))
    .join(" ");
}

export function sectionIntroMarkup(options, escapeHtml) {
  const settings = Object.assign(
    {
      eyebrow: "",
      title: "",
      description: "",
      badges: [],
      actionsMarkup: "",
      compact: false,
    },
    options || {}
  );
  const badgesMarkup = (settings.badges || [])
    .filter((item) => item && item.label)
    .map((item) => `<span class="${toneChipClass(item.tone)}">${escapeHtml(item.label)}</span>`)
    .join("");
  const classes = ["section-head", "system-section-head"];
  if (settings.compact) {
    classes.push("section-head-compact");
  }
  const actions = [badgesMarkup ? `<div class="tone-cluster">${badgesMarkup}</div>` : "", settings.actionsMarkup || ""]
    .filter(Boolean)
    .join("");
  return `
    <div class="${classes.join(" ")}">
      <div class="section-copy">
        ${settings.eyebrow ? `<p class="section-kicker">${escapeHtml(settings.eyebrow)}</p>` : ""}
        <h3 class="section-title">${escapeHtml(settings.title)}</h3>
        ${settings.description ? `<p class="section-subtitle">${escapeHtml(settings.description)}</p>` : ""}
      </div>
      ${actions ? `<div class="section-actions">${actions}</div>` : ""}
    </div>
  `;
}

export function metricTileMarkup(item, escapeHtml) {
  return `
    <article class="metric-card metric-tile tone-${normalizeTone(item.tone)}">
      <div class="eyebrow">${escapeHtml(item.label)}</div>
      <strong>${escapeHtml(item.value)}</strong>
      <p class="meta">${escapeHtml(item.detail)}</p>
    </article>
  `;
}
